import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-precio-anillos',
  templateUrl: './precio-anillos.component.html',
  styleUrls: ['./precio-anillos.component.scss']
})
export class PrecioAnillosComponent implements OnInit {
  enviroment = environment.BASE_URL;

  respuestaAnillos:any;
  anillos;
  data;
  datos;
  anilloId;
  respuestaDatos:any;
  respuestaUpdate:any;
  formularioEdit;

  constructor(private _agregarAnillo: ClientesService,
    private modalService: NgbModal,
    private _updateAnillo: ClientesService, private _getDetalleAnillo:ClientesService,
    private iziToast: Ng2IzitoastService, private _getAnillos: ClientesService) { }

  ngOnInit(): void {
    this.getPrecioAnillos();

    this.formularioEdit = {
      metal: '',
      gramaje: '',
      precio: '',
    }
  }

  getPrecioAnillos(){
    this._getAnillos.getPrecioAnillos().subscribe(
      data => {
        this.respuestaAnillos = data;
        if(this.respuestaAnillos.success){
          this.anillos = this.respuestaAnillos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getDetallePrecioAnillo(anillo){
    this.data = {
      'anillo':anillo,
    }
    this._getDetalleAnillo.getDetallePrecioAnillo(this.data).subscribe(
      data => {
        this.respuestaDatos = data;
        if(this.respuestaDatos.success){
          this.datos = this.respuestaDatos.content;
          this.formularioEdit.nombre = this.datos.nombre;
          this.formularioEdit.precio = this.datos.precio;
          this.formularioEdit.gramaje = this.datos.gramaje;
          this.formularioEdit.metal = this.datos.metal;
          this.anilloId = this.datos.id;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  updateAnilloPrecio(anillo, metal, peso){
    const formData = new FormData();
    formData.append('gramaje', peso);
    formData.append('metal', metal);
    formData.append('precio', this.formularioEdit.precio);
    formData.append('anillo', anillo);

    this._updateAnillo.updateAnilloPrecio(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getPrecioAnillos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }


}
